import { render } from "./BottomTabBar.vue?vue&type=template&id=36b4a54e&scoped=true"
import script from "./BottomTabBar.vue?vue&type=script&lang=js"
export * from "./BottomTabBar.vue?vue&type=script&lang=js"

import "./BottomTabBar.vue?vue&type=style&index=0&id=36b4a54e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36b4a54e"

export default script